import { render, staticRenderFns } from "./TenderList.vue?vue&type=template&id=2546e711&scoped=true&"
import script from "./TenderList.vue?vue&type=script&lang=js&"
export * from "./TenderList.vue?vue&type=script&lang=js&"
import style0 from "./TenderList.vue?vue&type=style&index=0&id=2546e711&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2546e711",
  null
  
)

export default component.exports